import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private isOnlineSignal = signal(navigator.onLine);

  constructor() {
    window.addEventListener('online', () => {
      this.isOnlineSignal.set(true);
    });

    window.addEventListener('offline', () => {
      this.isOnlineSignal.set(false);
    });
  }

  isOnline(): boolean {
    return this.isOnlineSignal();
  }

  get isOnline$() {
    return this.isOnlineSignal;
  }
}
